import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
  width={props.width || "20"}
  height={props.height || "20"}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_219_2207)">
      <path
        d="M23.0781 11.5391V9.89844H1.64062V14C1.64062 17.8008 3.64596 21.1893 6.6477 23.0781H18.0164C18.7535 22.6142 19.4836 22.0613 20.0856 21.4375H22.2578C25.4237 21.4375 28 18.8612 28 15.6953V11.5391H23.0781ZM26.3594 15.6953C26.3594 17.9568 24.5193 19.7969 22.2578 19.7969H21.365C22.4376 18.1372 23.0781 16.1199 23.0781 14V13.1797H26.3594V15.6953Z"
        fill="#556987"
      />
      <path
        d="M8.75391 0L7.84385 1.36505C8.1699 1.58216 8.35655 1.9314 8.35655 2.32318C8.35655 2.71496 8.1699 3.0642 7.84385 3.2813C7.06521 3.8004 6.60059 4.66878 6.60059 5.60443C6.60059 6.54008 7.06521 7.40846 7.84385 7.92755L8.75385 6.5625C8.4278 6.34539 8.24116 5.99616 8.24116 5.60438C8.24116 5.21259 8.4278 4.86336 8.75385 4.64625C9.53255 4.12721 9.99717 3.25883 9.99717 2.32312C9.99717 1.38748 9.53255 0.519094 8.75391 0Z"
        fill="#556987"
      />
      <path
        d="M12.8555 0L11.9454 1.36505C12.2715 1.58216 12.4581 1.9314 12.4581 2.32318C12.4581 2.71496 12.2715 3.0642 11.9454 3.2813C11.1668 3.8004 10.7021 4.66878 10.7021 5.60443C10.7021 6.54008 11.1668 7.40846 11.9454 7.92755L12.8554 6.5625C12.5294 6.34539 12.3427 5.99616 12.3427 5.60438C12.3427 5.21259 12.5294 4.86336 12.8554 4.64625C13.6341 4.12721 14.0987 3.25883 14.0987 2.32312C14.0987 1.38748 13.6341 0.519094 12.8555 0Z"
        fill="#556987"
      />
      <path
        d="M16.957 0L16.047 1.36505C16.373 1.58216 16.5597 1.9314 16.5597 2.32318C16.5597 2.71496 16.373 3.0642 16.047 3.2813C15.2683 3.8004 14.8037 4.66878 14.8037 5.60443C14.8037 6.54008 15.2683 7.40846 16.047 7.92755L16.957 6.5625C16.6309 6.34539 16.4443 5.99616 16.4443 5.60438C16.4443 5.21259 16.6309 4.86336 16.957 4.64625C17.7357 4.12721 18.2003 3.25883 18.2003 2.32312C18.2003 1.38748 17.7357 0.519094 16.957 0Z"
        fill="#556987"
      />
      <path
        d="M0 24.7188C0 26.5309 1.46907 28 3.28125 28H21.4375C23.2497 28 24.7188 26.5309 24.7188 24.7188H0Z"
        fill="#556987"
      />
    </g>
    <defs>
      <clipPath id="clip0_219_2207">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
